import { lazy } from 'react'

export const SocDashboard = lazy(
  () => import(/* webpackChunkName: "soc" */ './Dashboard/Dashboard')
)

export const AllInstallations = lazy(
  () =>
    import(/* webpackChunkName: "soc" */ './AllInstallations/AllInstallations')
)

export const ChangeInstallations = lazy(
  () =>
    import(
      /* webpackChunkName: "soc" */ './ChangeInstallations/ChangeInstallations'
    )
)

export const Events = lazy(
  () => import(/* webpackChunkName: "soc" */ './Events/Events')
)

export const SocUsers = lazy(
  () => import(/* webpackChunkName: "soc" */ './Users/Users')
)

export const SocUser = lazy(
  () => import(/* webpackChunkName: "soc" */ './User/User')
)
